export const BANNER_HEIGHT = 40;

export const DESKTOP_APP_BAR_HEIGHT = 61;

export const MOBILE_APP_BAR_HEIGHT = 52;

/** Native scrollbar width; used in layout calculations beside scrollable panes. */
export const SCROLLBAR_SIZE = 10;

export const DRAWER_WIDTH = 200;
export const COMPANY_SWITCHER_WIDTH = 80;
// 1396 = 1080 (content max width) + 280 + 36 (left and right padding)
export const SETTINGS_PAGE_MAX_WIDTH = 1396;
export enum AppViewMode {
  CLIENT = 'client',
  INTERNAL = 'internal',
}

export const TAILWIND_BREAKPOINT_WIDTHS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  xxl: 1440,
};
